module.exports = __webpack_public_path__ + "static/pic4-41b1951de3c7127e9a316813b1288e68.png";